import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Tooltip,
} from 'reactstrap';
import Select from 'react-select';
import moment from 'moment';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Property } from '../../../../../constants/APIs';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';
import ImageGallery from '../../../../../views/app/pages/propinfo/gallery/index';
import timeZoneOptions from '../../../../../data/timeZone';
import currencies from '../../../../../data/currencies';
import country from '../../../../../data/country';
import timeZoneList from '../../../../../data/timeZoneList';
import currencyList from '../../../../../data/currencyList';
import Validation from '../../../../../components/Validation';
export function BusinessProfileSetting({ propertyId, property, superAdmin }) {
  const [selectedCountry, setSelectedCountry] = useState({
    value: '',
    label: 'Please Select',
  });
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [selectZones, setSelectZones] = useState();
  const [startDate, setStartDate] = useState(null);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [propertyData, setpropertyData] = useState({
    groupId: getGroupID(),
    type: 'hotel',
    name: '',
    currency: 'NZD',
    inventoryProvider: 'External',
    ratesProvider: 'External',
    bookingProvider: 'External',
    timeZone: 'None',
    ariUrl: '',
    bookingUrl: '',
    creator: 'Manually',
    isTemplate: false,
    displayOrder: 1,
    country: 'NZ',
    status: 'Active',
    websiteLink: '',
    rooms: 0,
    starRating: 0,
    images: 'https://via.placeholder.com/150/',
    bmbAccountManager: '',
    bmbVoucherProcessingFee: 0,
    customerSuccessManager: '',
    isBmb: false,
    isAiva: false,
    isVirtualFrontDesk: false,
    isRateBooking: false,
    activationDate: null,
    redeemAddress: '',
    averageDailyRate: 0,
    averageHourlyWageRate: 0,
    legalBusinessName: '',
    businessAddress: '',
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);
  useEffect(() => {
    if (property !== null && property !== undefined) {
      setStartDate(
        moment(property.activationDate).format('MMM DD, YYYY') ===
          'Jan 01, 0001'
          ? null
          : moment(property.activationDate)
      );
      setpropertyData(property);
      let timeZones = timeZoneList.filter(
        (item) => item.IsoAlpha2 === property.country
      );
      const countryGroup = country.filter(
        (item) => item.code === property.country
      );
      let countrySelected = {
        value: countryGroup[0].code,
        label: countryGroup[0].name,
      };
      setSelectedCountry(countrySelected);
      setSelectZones(
        timeZones[0].TimeZones.map((zone) => {
          return <option value={zone}>{zone}</option>;
        })
      );
    }
  }, [property]);

  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
  };
  const handleRateChange = (e) => {
    setpropertyData({
      ...propertyData,
      starRating: e.rating,
    });
  };
  const handleCheckedChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.currentTarget.checked,
    });
  };
  const togglegallery = () => {
    // setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    setpropertyData({
      ...propertyData,
      images: image.src,
    });
  };

  //console.log(startDate);
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleChangeSelect = (value, { name }) => {
    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    setpropertyData({
      ...propertyData,
      country: value.value,
      currency: currency[0].currencyCode,
      timeZone: timeZones[0].TimeZones[0],
    });
    setSelectedCountry(value);
    setSelectZones(
      timeZones[0].TimeZones.map((zone) => {
        return <option value={zone}>{zone}</option>;
      })
    );
  };

  const handleSubmit = () => {
    const formmatedData = {
      ...propertyData,
      topics: property?.topics,
      updater: 'admin',
    };
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_Property}/${propertyId}`,
      data: formmatedData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        NotificationManager.success(
          '',
          'Profile update successfully',
          3000,
          null,
          null,
          'success'
        );
        // console.log(22, res.data);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        // toggle();
      }
    });
  };

  const selectTimeZoneOptions = timeZoneOptions
    .sort(dynamicSort('label'))
    .map((item) => {
      return <option value={item.value}>{item.label}</option>;
    });

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center">
            <h6>Business Profile</h6>
            <p>
              These settings can only be updated by the Super Admin. Contact
              support to make any changes.
            </p>
            <Separator className="mb-3" />
          </div>
          <Row className="">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>
                    Bussiness Name{' '}
                    <i className="demo-icon simple-icon-info" id="titletip"></i>
                  </Label>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="titletip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                  >
                    A short title which will appear when users ask about the
                    bussiness profile
                  </Tooltip>
                  <Input
                    type="text"
                    value={propertyData.name}
                    onChange={handleChange}
                    name="name"
                    disabled={!superAdmin}
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Bussiness Website</Label>
                  <Input
                    type="text"
                    value={propertyData.websiteLink}
                    onChange={handleChange}
                    name="websiteLink"
                    disabled={!superAdmin}
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Bussiness Type</Label>
                  <Input
                    type="select"
                    value={propertyData.type}
                    name="type"
                    onChange={handleChange}
                    disabled={!superAdmin}
                  >
                    <option value="CampGround">CampGround</option>
                    <option value="Hostel">Hostel</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Lodge">Lodge</option>
                    <option value="Motel">Motel</option>
                    <option value="Bach">Other Business Operator</option>
                    <option value="Pub">Pub</option>
                    <option value="Resort">Resort</option>
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Country</Label>
                  <Select
                    isMulti={false}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="code"
                    placeholder="Select Country"
                    onChange={handleChangeSelect}
                    value={selectedCountry}
                    isDisabled={!superAdmin}
                    options={
                      country
                        ? reactSelectOptionDiffrentPro(
                          country,
                          true,
                          'code',
                          'name',
                          ''
                        )
                        : []
                    }
                  />
                </Colxx>
                {selectZones !== undefined && selectZones.length > 0 && (
                  <Colxx sm={6} className="mb-3">
                    <Label>Time Zone</Label>
                    <Input
                      type="select"
                      value={propertyData.timeZone}
                      name="timeZone"
                      onChange={handleChange}
                      disabled={!superAdmin}
                    >
                      {selectZones}
                    </Input>
                  </Colxx>
                )}
                <Colxx sm={12} className="mb-3">
                  <Label>Legal Business Name</Label>
                  <Input
                    type="text"
                    value={propertyData.legalBusinessName}
                    name="legalBusinessName"
                    onChange={handleChange}
                    disabled={!superAdmin}
                  ></Input>
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Business Address</Label>
                  <Input
                    type="text"
                    value={propertyData.businessAddress}
                    name="businessAddress"
                    onChange={handleChange}
                    disabled={!superAdmin}
                  ></Input>
                </Colxx>
              </Row>
            </Colxx>

            <Fragment>
              <Colxx sm={12}>
                <h4>Logo</h4>
              </Colxx>
              <Colxx sm={12}>
                <Row>
                  <Colxx sm={2} className="md-3">
                    <img
                      style={{
                        width: '100%',
                        height: '90%',
                      }}
                      alt="room image"
                      src={
                        propertyData.images ||
                        'https://via.placeholder.com/150/'
                      }
                      disabled={!superAdmin}
                    />
                  </Colxx>
                  <Colxx sm={1} className="mb-3">
                    <Label>Browse</Label>
                    <div
                      className="iconsminds-photo"
                      onClick={(event) => togglegallery()}
                      style={{
                        cursor: 'pointer',
                        fontSize: '28px',
                        color: '#73236b',
                      }}
                      disabled={!superAdmin}
                    ></div>
                  </Colxx>
                </Row>
              </Colxx>
            </Fragment>
          </Row>
          {ImageGalleryButton()}
          <div className="text-center">
            {superAdmin === true && (
              <Button color="primary" onClick={handleSubmit}>
                Save
              </Button>
            )}
          </div>
        </CardBody>
      </Card>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
